<template>
  <div>
    <!-- sports -->
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <!-- Filter -->
        <v-card tile class="d-print-none mb-4">
          <v-container class="py-0 px-1">
            <v-form ref="form">
              <div class="d-flex overline justify-start align-center px-3">
                <!-- <v-divider class="mr-4"></v-divider> -->
                <v-icon class="grey--text" x-small>mdi-filter</v-icon>
                <div class="pl-2 grey--text" style="font-size: 10px">
                  {{ $t("filters") }}
                </div>
                <v-divider class="ml-4"></v-divider>
              </div>
              <v-btn-toggle class="hidden-xs-only" v-model="toggle">
                <v-row class="d-print-none px-2" no-gutters>
                  <v-col
                    v-for="(sport, index) in sports"
                    :key="index"
                    :cols="$vuetify.breakpoint.smAndDown ? '4' : '3'"
                  >
                    <v-btn
                      large
                      @click="
                        getDataSport(sport.id_sport),
                          (filter.id_sport = sport.id_sport)
                      "
                      style="flex: 1; width: 98%; margin: 0.1rem;"
                    >
                      <v-icon left size="16">{{
                        iconT(sport.id_sport)
                      }}</v-icon>
                      {{ sport.name_sport }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-btn-toggle>
              <v-col>
                <v-row>
                  <v-autocomplete
                    v-model="filter.id_sport"
                    :items="sports"
                    @change="getDataSport(filter.id_sport)"
                    label="Selecione um esporte"
                    item-text="name_sport"
                    item-value="id_sport"
                    dense
                    filled
                    hide-details
                    solo-inverted
                    clearable
                    class="hidden-sm-and-up"
                  >
                    <template v-slot:item="data">
                      <v-icon left size="16">{{
                        iconT(data.item.id_sport)
                      }}</v-icon>
                      {{ data.item.name_sport }}
                    </template>
                  </v-autocomplete>

                  <v-autocomplete
                    v-model="filter.id_market"
                    @change="doFilter()"
                    :items="listMarkets"
                    class="mt-2"
                    :label="$t('selectAMarket')"
                    item-text="name"
                    item-value="value"
                    dense
                    filled
                    hide-details
                    solo-inverted
                    clearable
                  >
                  </v-autocomplete>
                </v-row>
              </v-col>
            </v-form>
          </v-container>
        </v-card>
        <!-- Filter -->
      </v-col>
    </v-row>
    <!-- end sports -->

    <!--*********************************************************************************************************-->
    <!--************ Cards Odds    ******************************************************************************-->
    <!--*********************************************************************************************************-->

    <div
      v-for="(market, marketIndex) in data"
      :key="marketIndex"
      class="table-market-margin mb-8"
      :style="{
        width: $vuetify.breakpoint.smAndUp ? '600px' : '',
        margin: '0 auto',
      }"
    >
      <v-card>
        <v-toolbar elevation="0">
          <v-toolbar-title class="subtitle-1">
            {{ market.data_market.name_market }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-switch
            class="mt-2"
            v-model="market.activeMarket"
            @change="
              enableDesableMarket(market, market.id_market, market.activeMarket)
            "
          ></v-switch>
        </v-toolbar>

        <div class="container pt-0">
          <v-row
            class="mb-2 px-6"
            :class="$vuetify.breakpoint.xs ? 'd-none' : 'd-flex'"
          >
            <v-col cols="4" sm="3" md="3" lg="3" xl="3"> </v-col>
            <v-col
              cols="4"
              sm="3"
              md="3"
              lg="3"
              xl="3"
              class="pt-4 text-center subtitle-2"
              >{{ $t("preGame") }}</v-col
            >
            <v-col
              cols="4"
              sm="3"
              md="3"
              lg="3"
              xl="3"
              class="pt-4 text-center subtitle-2"
              >{{ $t("Live") }}
            </v-col>
            <v-col
              cols="4"
              sm="3"
              md="3"
              lg="3"
              xl="3"
              class="pt-4 text-center subtitle-2"
              >{{ $t("oddMax") }}</v-col
            >
          </v-row>

          <v-row
            class="ma-0 pa-0"
            v-for="(outcome, outcomeIndex) in market.outcomes"
            :key="outcomeIndex"
          >
            <v-col
              cols="12"
              sm="3"
              md="3"
              lg="3"
              xl="3"
              class="pa-2 subtitle-2 d-flex align-center justify-start"
            >
              <v-checkbox
                v-model="outcome.selected"
                dense
                class="ma-0"
                @click="
                  enableDesableOutcome(market, outcome.id_outcome, outcome)
                "
              ></v-checkbox>
              <div :class="outcome.selected == 0 ? 'text--disabled' : ''">
                {{ outcome.data_outcome.name_outcome.replace("(ht/ft)", "") }}
              </div>
            </v-col>
            <v-col cols="4" sm="3" md="3" lg="3" xl="3" class="px-1 py-0">
              <div
                :class="$vuetify.breakpoint.xs ? 'd-flex' : 'd-none'"
                class="align-center flex-row-reverse"
              >
                <span class="subtitle-2 mr-auto">Pré Jogo</span>
              </div>
              <v-text-field
                v-model="outcome.margin_prematch"
                type="text"
                class="relative"
                :class="$vuetify.breakpoint.xs ? 'my-2' : 'my-0'"
                @keypress="isNumber($event)"
                @change="
                  marginChanged(outcome, marketIndex, outcomeIndex, false)
                "
                @focus="outcome.oldMargin = outcome.margin_prematch"
                @blur="
                  updateOdd(
                    'prematch',
                    outcome.id_outcome,
                    outcome.margin_prematch
                  )
                "
                append-icon="%"
                solo-inverted
                required
                dense
                :disabled="!outcome.selected"
              ></v-text-field>
            </v-col>

            <v-col cols="4" sm="3" md="3" lg="3" xl="3" class="px-1 py-0">
              <div
                :class="$vuetify.breakpoint.xs ? 'd-flex' : 'd-none'"
                class="align-center flex-row-reverse"
              >
                <span class="subtitle-2 mr-auto">{{ $t("Live") }}</span>
              </div>
              <v-text-field
                v-model="outcome.margin_live"
                type="text"
                class="relative"
                :class="$vuetify.breakpoint.xs ? 'my-2' : 'my-0'"
                @keypress="isNumber($event)"
                @change="
                  marginChanged(outcome, marketIndex, outcomeIndex, true)
                "
                @focus="outcome.oldMarginLive = outcome.margin_live"
                @blur="
                  updateOdd('live', outcome.id_outcome, outcome.margin_live)
                "
                append-icon="%"
                solo-inverted
                required
                dense
                :disabled="!outcome.selected"
              ></v-text-field>
            </v-col>

            <v-col cols="4" sm="3" md="3" lg="3" xl="3" class="px-1 py-0">
              <div
                :class="$vuetify.breakpoint.xs ? 'd-flex' : 'd-none'"
                class="align-center flex-row-reverse"
              >
                <span class="subtitle-2 mr-auto">{{ $t("oddMax") }}</span>
              </div>

              <v-text-field
                v-model="outcome.max_odd"
                type="text"
                class="relative"
                :class="$vuetify.breakpoint.xs ? 'my-2' : 'my-0'"
                @keypress="isNumber($event)"
                @change="formatDecimal"
                @blur="
                  updateOdd('max_odd', outcome.id_outcome, outcome.max_odd)
                "
                solo-inverted
                required
                dense
                :disabled="!outcome.selected"
              ></v-text-field>
            </v-col>

            <v-scale-transition>
              <v-alert
                v-if="
                  outcome.alertMarginCashout || outcome.alertMarginLiveCashout
                "
                class="pl-3 mt-1"
                type="info"
                dense
                border="left"
                text
                style="font-size: 0.9em;"
              >
                <span v-if="outcome.alertMarginCashout">
                  {{
                    $t("marginChangedAlertMessage", {
                      type: $t("preGame").toLowerCase(),
                      oldMargin: outcome.oldMargin,
                      currentMargin: outcome.margin_prematch,
                    })
                  }}
                </span>
                <span v-else-if="outcome.alertMarginLiveCashout">
                  {{
                    $t("marginChangedAlertMessage", {
                      type: $t("live").toLowerCase(),
                      oldMargin: outcome.oldMarginLive,
                      currentMargin: outcome.margin_live,
                    })
                  }}
                </span>
              </v-alert>
            </v-scale-transition>
          </v-row>
        </div>
      </v-card>
    </div>
    <!--END CARDS ODDS *********************************************************************************-->
  </div>
</template>

<script>
import { icon } from "@/components/icon-sport/icon.js";
export default {
  name: "administrator-settings-markets-margins",
  data: () => ({
    data: [],
    originalArray: [],
    listMarkets: [],
    filterArray: [],
    filter: {
      id_sport: 6046,
      id_market: "",
    },
    count: 3,
    toggle: 0,
  }),

  computed: {
    markets() {
      return this.$store.state.markets;
    },
    outcomes() {
      return this.$store.state.outcomes;
    },
    sports() {
      return this.$store.state.sports;
    },
  },

  watch: {
    markets(val) {
      val && this.getDataSport(this.filter.id_sport);
    },

    "filter.id_market": function(val) {
      if (val == undefined) {
        this.data = [];
        this.count = 3;
        this.addDataScrolling();
      }
    },
  },

  created() {
    const winHeight = window.innerHeight;
    const _this = this;
    document.addEventListener("scroll", function(e) {
      const winScroll = window.scrollY;
      const { scrollHeight } = e.target.body;
      if (Math.round(scrollHeight - winScroll) === winHeight) {
        _this.count = _this.count + 2;
        _this.addDataScrolling();
      }
    });
  },

  mounted() {
    // console.log(this.$vuetify.breakpoint);
    if (this.markets.length == 0) return;
    this.getDataSport(this.filter.id_sport);
    this.toggle = 0;
  },

  methods: {
    marginChanged(outcome, marketIndex, outcomeIndex, live) {
      const oldMarginField = live ? "oldMarginLive" : "oldMargin";
      const valueField = live ? "margin_live" : "margin_prematch";

      const oldMargin = Number(outcome[oldMarginField]);

      const alertMarginCashout =
        oldMargin < 0 && Number(outcome[valueField]) > oldMargin;

      if (alertMarginCashout) {
        this.updateOutcomeAlert(
          marketIndex,
          outcomeIndex,
          alertMarginCashout,
          live
        );

        setTimeout(() => {
          this.updateOutcomeAlert(marketIndex, outcomeIndex, false, live);
        }, 7000);
      }
    },

    updateOutcomeAlert(marketIndex, outcomeIndex, status, live) {
      const field = live ? "alertMarginLiveCashout" : "alertMarginCashout";

      this.data[marketIndex].outcomes = this.data[marketIndex].outcomes.map(
        (outcome, index) => {
          if (outcomeIndex === index) {
            outcome[field] = status;
          }

          return outcome;
        }
      );
    },

    reset() {
      this.count = 3;
      this.filter.id_market = "";
      this.listMarkets = [];
      this.data = [];
    },

    async getDataSport(id_sport) {
      this.reset();

      const request = await this.$request.post(
        "/administrator/settings/marketsMargin",
        { id_sport }
      );
      const boolean = { 0: false, 1: true };

      request.dados.markets.forEach((item) => {
        item.data_market = this.markets.filter(
          (m) => m.id_market == item.id_market
        )[0];
        const selectedsOutcome = item.outcomes.map(
          (outcome) => boolean[outcome.selected]
        );
        item.activeMarket = selectedsOutcome.reduce((a, b) => a || b);
        item.outcomes.forEach((outcome) => {
          outcome.data_outcome = this.outcomes.filter(
            (o) => o.id_outcome == outcome.id_outcome
          )[0];
          outcome.selected = boolean[outcome.selected];
          outcome.margin_live =
            outcome.margin_live < 1
              ? outcome.margin_live * 100
              : outcome.margin_live;
          outcome.margin_prematch =
            outcome.margin_prematch < 1
              ? outcome.margin_prematch * 100
              : outcome.margin_prematch;
          outcome.max_odd =
            outcome.max_odd < 1 ? outcome.max_odd * 100 : outcome.max_odd;
        });

        if (item.data_market) {
          this.listMarkets.push({
            name: item.data_market.name_market,
            value: item.data_market.id_market,
          });
        }
      });

      this.filterArray = request.dados.markets;
      this.originalArray = request.dados.markets;
      this.addDataScrolling();
    },

    addDataScrolling() {
      if (this.filter.id_market != "" && this.filter.id_market != undefined)
        return;
      this.data = [];
      this.$store.commit("setFeedbackProgress", true);
      this.originalArray.filter((item, index) => {
        if (index < this.count) {
          this.data.push(item);
        }
      });
      this.$store.commit("setFeedbackProgress", false);
    },

    doFilter() {
      const { id_market } = this.filter;
      this.data = this.filterArray.filter(
        (item) => item.id_market == id_market
      );
    },

    async updateOdd(type, id_outcome, value) {
      const request = await this.$request.post(
        "/administrator/settings/changeValueOutcome",
        { type, id_outcome, value }
      );

      if (request.dados && request.dados.clear) {
        this.$store.commit("setFeedbackSnack", {
          msg: request.messages,
          color: "success",
        });
      }
    },

    async enableDesableMarket(market, id_market, switchMarket) {
      //  Enable/Disable Market
      const { id_sport } = this.filter;
      const request = await this.$request.post(
        "/administrator/settings/insertMarket",
        { id_sport, id_market, selected: switchMarket ? 1 : 0 }
      );

      //  Enable/Disable Outcome
      market.outcomes.forEach((outcome) => (outcome.selected = switchMarket));

      // Feedback
      this.$store.commit("setFeedbackSnack", {
        msg: request.messages,
        color: request.dados.clear ? "success" : "error",
      });
    },

    async enableDesableOutcome(market, id_outcome, outcome) {
      // Enable/Disable Market
      const selectedsOutcome = market.outcomes.map((outcome) =>
        outcome.selected == 1 ? true : false
      );
      market.activeMarket = selectedsOutcome.reduce((a, b) => a || b);

      //  Enable/Disable Outcome
      const request = await this.$request.post(
        "/administrator/settings/insertOutcomes",
        { id_outcome, selected: outcome.selected ? 1 : 0 }
      );
      outcome.margin_live = 0;
      outcome.margin_prematch = 0;
      outcome.max_odd = 0;

      // FeedBack
      this.$store.commit("setFeedbackSnack", {
        msg: request.messages,
        color: request.dados.clear ? "success" : "error",
      });
    },

    // Colocalem formato decimal
    formatDecimal(field) {
      if (!field.isDecimal) return;
      field.model = Number(field.model.replace(",", ".")).toFixed(2);
    },

    // Verifica se é numero
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    iconT: (id) => icon(id),
  },
};
</script>

<style>
.table-market-margin .v-text-field__details,
.table-market-margin .v-messages {
  display: none;
}
.table-market-margin .b-none {
  height: 0 !important;
  padding: 0 16px !important;
  margin: 0 !important;
  border: none !important;
}
.table-market-margin .v-icon {
  font-size: 16px;
}

.table-market-margin .v-toolbar,
.table-market-margin .v-toolbar__content {
  height: 50px !important;
}
</style>
